import { css, styled } from '@mui/material';

export const SImage = styled('img')(
  () => css`
    max-width: 471px;
    max-height: 286px;
    margin-bottom: -24px;
    margin-right: -24px;
  `,
);
